<div class="col-md-10">
  <div class="row">
    <div class="col-sm-6 col-xs-4 font-weight-bold">Medlemsid:</div>
    <div class="col-sm-6 col-xs-4"><a [routerLink]="['/memberform/id/', member.id]">{{member.id}}</a></div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-xs-4 font-weight-bold">Förnamn:</div>
    <div class="col-sm-6 col-xs-4">{{member.givenName}}</div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-xs-4 bold">Efternamn:</div>
    <div class="col-sm-6 col-xs-4">{{member.familyName}}</div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-xs-4 font-weight-bold">Ort:</div>
    <div class="col-sm-6 col-xs-4">{{member.homeCity}}</div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-xs-4 font-weight-bold">Institution:</div>
    <div class="col-sm-6 col-xs-4"><b>{{member.institutionShortName}}</b> {{member.institutionName}}</div>
  </div>
</div>